import styles from './styles.less';


const SharingLinks = (props) => {
    const className = cx(styles.root, props.className);
    const linkClassName = cx(styles.link, props.linkClassName);
    return (
        <div className={ className }>
            { !!props.label &&
            <span className={ styles.title }>{ props.label }</span> }
            <a className={ linkClassName }
                href={`http://www.facebook.com/share.php?u=${props.url}`}
                target='_blank'>
                Facebook
            </a>
            <a className={ linkClassName }
                href={`http://twitter.com/share?status=${props.url}`}
                target='_blank'>
                Twitter
            </a>
        </div>
    );
}

SharingLinks.propTypes = {
    label: React.PropTypes.string,
    linkClassName: React.PropTypes.string,
    url: React.PropTypes.string.isRequired
};

SharingLinks.defaultProps = {
    label: 'Share this page:'
};


export default SharingLinks;



/** WEBPACK FOOTER **
 ** ./src/common/components/sharing-links/index.js
 **/